<template>
  <div>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      app
    >
      <v-list two-line>
        <v-list-tile href="/" target="_new">
          <v-list-tile-action>
            <v-icon>arrow_back</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zurück zur Webseite</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile href="/de/hilfe/feedback" target="_new">
          <v-list-tile-action>
            <v-icon>feedback</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Feedback</v-list-tile-title>
            <v-list-tile-sub-title>Vielen Dank für Ihr Feedback</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--
        <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon>contact_mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contact</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        -->
      </v-list>
    </v-navigation-drawer>

    <v-toolbar color="primary" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

      <v-toolbar-title>
        <fa-icon icon="laptop-medical"></fa-icon>
        TARMED Validator
        <v-chip color="white" outline small disabled>Beta</v-chip>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!--
        Add Feedback in dot-menu
      -->

      <!--
      <v-btn icon>
        <fa-icon icon="compass" class="v-icon"></fa-icon>
      </v-btn>
      -->

      <!--
      <v-select :items="['foo', 'bar']">
      </v-select>
      -->
    </v-toolbar>

  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false
    }
  }
}
</script>

<style scoped>
.v-toolbar__title svg.svg-inline--fa {
  color: #fff;
}
</style>
